import { TransferOrderReceivingCreatePage } from "@/features/po-receiving/pages/transfer-order/TransferOrderReceivingCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/receiving/transfer-order/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["to_receiving.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: TransferOrderReceivingCreatePage,
});
